import { all, call, getContext, put, select, take, throttle } from 'redux-saga/effects';
import { damzOnline } from '../actions/initialization';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { refreshCounter, setGlobalCounter } from '../actions/counter';
import ddt from '@wix/da-ddt';
function* fetchFreshCounts() {
    const user = yield select(getCurrentUser);
    const client = yield getContext('supaClient');
    const { data, error } = yield client.from('user_unread_count').select('conversations').eq('user_id', user.useridUuid).maybeSingle();
    if (error) {
        // TODO
        // do we mark as offline? Ignore or retry?
        ddt.error('damz', 'Failed to get global counter', error);
        return;
    }
    if (data) {
        yield put(setGlobalCounter(data.conversations));
    }
}
/**
 * Handles counts
 */ export function* counterSaga() {
    yield take(damzOnline); // wait for online to happen
    yield all([
        call(fetchFreshCounts),
        throttle(1000, refreshCounter, fetchFreshCounts)
    ]);
}

//# sourceMappingURL=counter.js.map